import type { MetaFunction } from "@remix-run/node";
import { Form } from "@remix-run/react";
import { getPageTitle } from "~/operations/getPageTitle";
import { Field, Label } from "~/components/base/fieldset";
import { Input } from "~/components/base/input";
import { action } from "./action";
import { SubmitButton } from "~/components/submitButton";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useState } from "react";

export { action };

export const meta: MetaFunction = () => {
  return [{ title: getPageTitle("Login") }];
};

export default function LoginIndex() {
  const searchParams = new URLSearchParams({ index: "" });
  const [date, setDate] = useState<Date | null>(null);

  return (
    <Form className="space-y-6" method="post">
      <Field>
        <Label>Employee Number</Label>
        <Input
          name="employee_number"
          type={"number"}
          required
          autoFocus
          placeholder=""
        />
      </Field>
      <Field>
        <Label>Date of Birth</Label>
        <div className="w-full pt-3">
          <DatePicker
            name="dob"
            selected={date}
            onChange={(date: Date | null) => setDate(date)}
            dateFormat="MM/dd/yyyy"
            placeholderText="MM/dd/yyyy"
            required
            wrapperClassName="w-full"
            className="relative w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:border-gray-600 dark:bg-white/5 dark:text-white dark:focus:border-blue-500 dark:focus:ring-blue-500"
          />
        </div>
      </Field>
      <SubmitButton className="w-full" />
    </Form>
  );
}
